import { useIntervalFn } from '@vueuse/core'
import { onUnmounted, ref } from 'vue'

export function useCountDown(params: {
  default: number
  autoStart?: boolean
  onEnd?: () => void
}) {
  const time = ref<number>(params.default || 60)
  const { pause, resume, isActive } = useIntervalFn(() => {
    time.value--
    if (time.value <= 0) {
      pause()
      params.onEnd?.()
    }
  }, 1000, {
    immediate: params.autoStart || false,
  })

  // 添加组件卸载时的清理逻辑
  onUnmounted(() => {
    pause()
  })

  return {
    time,
    start() {
      if (isActive.value)
        return

      if (time.value <= 0)
        time.value = params.default
      resume()
    },
    isActive,
    setTime(value: number) {
      time.value = value
    },
    reset() {
      time.value = params.default
      resume()
    },
  }
}
